export default __webpack_public_path__ + "assets/CapitalOne-51b83c1542c34efdfaf6bb7ca4907330.svg";